import React, { useEffect, useState } from 'react';
import { fetchAuthenticatedFile } from './apiClient';

// Shows a protected upload (Aadhaar image/PDF) in a popup on the same page instead of
// a new tab: the file never gets its own tab or address, and its blob URL is revoked
// as soon as the popup closes. Close with the ✕ button, Escape, or a click outside.
export default function FileViewer({ path, title, onClose }) {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let blobUrl = null;
    let cancelled = false;
    fetchAuthenticatedFile(path)
      .then(f => {
        blobUrl = f.url;
        if (cancelled) URL.revokeObjectURL(f.url);
        else setFile(f);
      })
      .catch(e => { if (!cancelled) setError(e.message || 'Could not open file'); });
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="file-viewer-title"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000, padding: 16 }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 14, padding: 16, width: '100%', maxWidth: 900, maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 12 }}>
          <h3 id="file-viewer-title" style={{ margin: 0, color: 'var(--ink)', fontSize: 16, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</h3>
          <button
            autoFocus
            onClick={onClose}
            aria-label="Close"
            style={{ background: 'var(--line)', color: 'var(--ink-soft)', border: 'none', borderRadius: 8, padding: '6px 12px', fontWeight: 'bold', cursor: 'pointer' }}
          >✕</button>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface-alt)', borderRadius: 8 }}>
          {error ? (
            <p style={{ color: '#b91c1c', padding: 24 }}>{error}</p>
          ) : !file ? (
            <p style={{ color: 'var(--muted)', padding: 24 }}>Loading…</p>
          ) : file.type === 'application/pdf' ? (
            <iframe title={title} src={file.url} style={{ width: '100%', height: '75vh', border: 'none' }} />
          ) : (
            <img src={file.url} alt={title} style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain' }} />
          )}
        </div>
      </div>
    </div>
  );
}
